define('controller/ReviewController',['require','lib/controller/BaseController','collection/ReviewCollection','model/ReviewClientModel','view/controller/review/ReviewLayoutView','lib/plugin/PluginBroker','Config','lib/WindowMessageListener'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var ReviewCollection = require('collection/ReviewCollection');
    var ReviewClientModel = require('model/ReviewClientModel');
    var ReviewLayoutView = require('view/controller/review/ReviewLayoutView');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var Config = require('Config');
    var WindowMessageListener = require('lib/WindowMessageListener');

    /**
     * Reviews Controller
     *
     * @class ReviewsController
     */
    return BaseController.extend({

        _collection: null,
        _reviewClientModel: null,
        _clientModel: null,

        /**
         * Initialize controller object
         */
        initialize: function () {
            this.initOpenIdAuth();

            BaseController.prototype.initialize.apply(this);
        },

        /**
         * index action, displays list of images
         */
        index: function(page) {
            var limit = Config.getInstance().getOption('reviews_count');

            if (!this._collection) {
                this._collection = new ReviewCollection();
            }
            if(limit && !_.isNull(limit)) {
                this._collection.setLimit(limit);
            }
            if(page && page>0) {
                this._collection.setPage(page);
            }
            this._collection.fetch({reset:true});

            if (!this._reviewClientModel) {
                this._reviewClientModel = new ReviewClientModel();
                this._reviewClientModel.fetch();
            }

            if (!this._clientModel) {
                if (Config.getInstance().getPluginStatus('client_login')) {
                    var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                    this._clientModel = clientPlugin.getClientModel();
                }
            }

            var indexView = new ReviewLayoutView({
                collection: this._collection,
                reviewClientModel: this._reviewClientModel,
                clientModel: this._clientModel,
            });

            this.getMainLayout().getContentRegion().show(indexView);
        },

        /**
         * Subscribe to message window event
         */
        initOpenIdAuth: function () {
            var listener = new WindowMessageListener();
            this.listenTo(listener, 'message', _.bind(this._handleWindowMessage, this));
        },

        /**
         * Handle open id login message
         *
         * @private
         */
        _handleWindowMessage: function (data) {
            if (data.review_open_id_message) {
                if (this._reviewClientModel) {
                    this._reviewClientModel.fetch();
                }
            }
        }

    });

});
